import { useProperty, useTranslation } from '@eti/providers';
import { constants } from '@eti/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const Age = _ref => {
  let {
    age
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const label = t(age === 1 ? 'TravelerForm.Year.Singular' : 'TravelerForm.Year.Plural', age);
  const commaSeparator = p('IbeClient.CommaSeparator.Enabled') ? ',' : '';
  const ageDisplay = label === '' ? label : `${commaSeparator} ${label}`;
  return /*#__PURE__*/_jsx("span", {
    className: MOUSE_FLOW_CLASS_NAMES,
    "data-testid": "ageDisplay",
    children: ageDisplay
  });
};
export default Age;
//# sourceMappingURL=Age.js.map